// Author:Egemen Alkan
function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

// Show/hide the scroll-to-top button based on scroll position
window.addEventListener('scroll', () => {
    const scrollToTopBtn = document.querySelector('.scroll-to-top');
    if (window.scrollY > 300) {
        scrollToTopBtn.style.display = 'block';
    } else {
        scrollToTopBtn.style.display = 'none';
    }
});

(function () {
    const images = document.querySelectorAll('.slideshow img');
    let currentIndex = 0;

    function showImage(index) {
        // Hide all images
        for (let i = 0; i < images.length; i++) {
            images[i].style.display = 'none';
        }

        // Show the image at the specified index
        images[index].style.display = 'block';
    }

    function nextImage() {
        currentIndex++;
        if (currentIndex >= images.length) {
            currentIndex = 0; // Restart from the first image
        }
        showImage(currentIndex);
    }

    // Start the slideshow
    showImage(currentIndex);
    setInterval(nextImage, 3000); // Change image every 3 seconds
})();
